/**
 * PropertyCheckedIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const PropertyCheckedIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M10.813 16.62a1 1 0 0 1-.71-.295l-2.12-2.12a1 1 0 1 1 1.41-1.42l1.42 1.42 3.54-3.54a1 1 0 1 1 1.41 1.42l-4.24 4.24a1 1 0 0 1-.71.296" />
    <path
      fillRule="evenodd"
      d="m12.423 2.165 10.5 7a1 1 0 0 1-.55 1.83.94.94 0 0 1-.55-.17l-.95-.63v11.3a1 1 0 0 1-1 1h-16a1 1 0 0 1-1-1v-11.3l-.9.63a1 1 0 0 1-1.1-1.66l10.45-7a1 1 0 0 1 1.1 0m-7.55 18.33h14V8.865l-7-4.67-7 4.67z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const PropertyCheckedIcon = makeIcon('PropertyCheckedIcon', PropertyCheckedIconSvg)
